import {getDefaultPieFormatting} from "@/containers/E4ImpactMBA/charts/pie";

const transformData = [
    {
        name: 'Legal, Tax & Accounting',
        color: '#5b9bd5',
        value: 'Accounting',
    },
    {
        name: 'Agribusiness',
        color: '#ed7d32',
        value: 'Agrifood',
    },
    {
        name: 'Automotive',
        color: '#a5a5a5',
        value: 'Automotive',
    },
    {
        name: 'Art and Culture',
        color: '#fec000',
        value: 'Art and Culture',
    },
    {
        name: 'Business Service',
        color: '#fec000',
        value: 'Business Service',
    },
    {
        name: 'Consulting',
        color: '#fec000',
        value: 'Consulting',
    },
    {
        name: 'Cosmetics',
        color: '#fec000',
        value: 'Cosmetics',
    },
    {
        name: 'Education, Research & Development',
        color: '#fec000',
        value: 'Education',
    },
    {
        name: 'Banking, Finance & Insurance',
        color: '#fec000',
        value: 'Finance',
    },
    {
        name: 'Energy',
        color: '#fec000',
        value: 'Energy',
    },
    {
        name: 'Fashion and Textile',
        color: '#fec000',
        value: 'Fashion and Textile',
    },
    {
        name: 'Food & Beverage Processing',
        color: '#fec000',
        value: 'Food Processing',
    },
    {
        name: 'Healthcare',
        color: '#fec000',
        value: 'Health',
    },
    {
        name: 'Housing, Construction & Infrastructure',
        color: '#fec000',
        value: 'Housing and Construction',
    },
    {
        name: 'ICT',
        color: '#fec000',
        value: 'ICT',
    },
    {
        name: 'Leisure',
        color: '#fec000',
        value: 'Leisure',
    },
    {
        name: 'Manufacturing and consumer goods',
        color: '#fec000',
        value: 'Manufacturing and consumer goods',
    },
    {
        name: 'Mechanical engeneering',
        color: '#fec000',
        value: 'Mechanical engeneering',
    },
    {
        name: 'Media, PR, marketing & communication',
        color: '#fec000',
        value: 'Media, PR, digital comunication and marketing',
    },
    {
        name: 'Oil, gas & mining',
        color: '#fec000',
        value: 'Oil and gas',
    },
    {
        name: 'Pharmaceuticals',
        color: '#fec000',
        value: 'Pharmaceuticals',
    },
    {
        name: 'Personal services',
        color: '#fec000',
        value: 'Personal services',
    },
    {
        name: 'Public Administration',
        color: '#fec000',
        value: 'Public Administration',
    },
    {
        name: 'Real Estate',
        color: '#fec000',
        value: 'Real Estate',
    },
    {
        name: 'Green Energy',
        color: '#fec000',
        value: 'Renewable Energy',
    },
    {
        name: 'Tourism and Hospitality',
        color: '#fec000',
        value: 'Tourism and Hospitality',
    },
    {
        name: 'Waste Management',
        color: '#fec000',
        value: 'Waste Management',
    },
    {
        name: 'Water Management',
        color: '#fec000',
        value: 'Water Management',
    },
    {
        name: 'Wholesale and retail trade',
        color: '#fec000',
        value: 'Wholesale and retail trade',
    },
    {
        name: 'NGO',
        color: '#fec000',
        value: 'NGO',
    },
    {
        name: 'Packaging',
        color: '#fec000',
        value: 'Packaging',
    },
    {
        name: 'Transport & Logistics',
        color: '#fec000',
        value: 'Transport & Logistics',
    },
];

/**
 * question: What is the sector of your business or business idea?
 * == baseline
 * sector_t0
 * 
 * @param props 
 * @returns 
 */
export const typeSectorChartCalculation = (props: any) => {
    return getDefaultPieFormatting(
        'Type of Sector',
        transformData.map(({name, color, value}) => ({
            name,
            y: props.baselineSubmissions.filter((submission: any) => submission.sector_t0 === value).length
        }))
    );
}